export default "__VITE_ASSET__6995ceaa__"